import { ILoggedCustomer } from "api/types";
import { ApolloClient } from "apollo-boost";
import { AppStateContext } from "AppState";
import NumPad, { MediumCenteredNumPad } from "components/common/NumPad";
import RightLeftLayout from "components/common/RightLeftLayout/RightLeftLayout";
import { ConfigurationLoaderContext } from "components/Gates/ConfigurationLoaderGate";
import { CustomerDataContext } from "components/Gates/CustomerDataGate";
import { History, LocationState } from "history";
import * as React from "react";
import { ApolloConsumer } from "react-apollo";
import strings from "static/strings.js";
import {
  getCurrentLocation,
  redeemPointsForReward,
  validateTenantUserPin
} from "utils/apis";
import Footer from "./Footer";
import RewardsList from "./RewardsList";

interface IProps {
  name?: string;
  history: History;
  location: LocationState;
  rewardImageBaseUrl?: string;
  locationName: string;
}

interface IRedeemConfirmationState {
  totalPrice: string;
  budtenderId: string;
  goodPin?: boolean;
  wrongPin?: boolean;
  promoCode: string;
  tenantId: string;
  locationId: string;
  redeeming?: boolean;
}

class RedeemConfirmation extends React.Component<
  IProps & {
    client: ApolloClient<any>;
    loggedCustomer: ILoggedCustomer | undefined;
  },
  IRedeemConfirmationState
> {
  constructor(
    props: IProps & {
      client: ApolloClient<any>;
      loggedCustomer: ILoggedCustomer | undefined;
    }
  ) {
    super(props);
    this.state = {
      totalPrice: "$0",
      budtenderId: "",
      promoCode: "",
      tenantId: "",
      locationId: ""
    };
  }

  public async componentDidMount() {
    await this.getCurrentUser();
  }

  public render() {
    const { rewards, total } = this.props.location.state;
    return (
      <RightLeftLayout
        title={this.props.locationName}
        titleSecondary="Confirm Rewards"
        closeButtonHandler
        leftPanel={
          <React.Fragment>
            <RewardsList
              rewards={rewards}
              imageBaseUrl={this.props.rewardImageBaseUrl}
              tenantId={this.state.tenantId}
              locationId={this.state.locationId}
              transparentBackground
            />
            <Footer
              redeem={this.redeemReward}
              redeeming={this.state.redeeming}
              budtenderId={this.state.budtenderId}
              goodPin={this.state.goodPin}
              wrongPin={this.state.wrongPin}
              total={total}
            />
          </React.Fragment>
        }
        rightPanel={
          <MediumCenteredNumPad>
            <NumPad onTap={this.onTap} />
          </MediumCenteredNumPad>
        }
      />
    );
  }

  private onTap = (value: string) => {
    const currentValue = this.state.budtenderId;
    let newValue = "";
    if (value === "back" && currentValue.length > 0) {
      newValue = currentValue.slice(0, currentValue.length - 1);
    } else if (currentValue.length < 4) {
      if (value === "back") {
        return;
      }
      newValue = `${currentValue}${value}`;
    } else {
      return;
    }

    if (newValue.length === 4) {
      this.validateBudtenderPin(newValue);
    }

    this.setState({ budtenderId: newValue, goodPin: false, wrongPin: false });
  };

  private redeemReward = async () => {
    const { rewards } = this.props.location.state;
    try {
      if (this.state.redeeming) {
        return;
      }
      this.setState({
        redeeming: true
      });
      const pointsRedemptionResult: any = await redeemPointsForReward(
        this.props.client,
        this.props.loggedCustomer ? this.props.loggedCustomer.authToken : "",
        this.state.budtenderId,
        rewards.map((reward: any) => ({
          id: reward.id,
          quantity: parseInt(reward.quantity, 10)
        }))
      );

      if (pointsRedemptionResult) {
        const newState = {
          rewards,
          total: pointsRedemptionResult.pointsUsed,
          pointsBalance: pointsRedemptionResult.updatedCustomerPointBalance
        };
        this.setState({ goodPin: true, wrongPin: false, redeeming: false });
        this.props.history.push("/redeem-complete", newState);
      } else {
        this.setState({ wrongPin: true, redeeming: false });
      }
    } catch (err) {
      this.setState({
        redeeming: false
      });
      console.error("couldn't redeem reward", err);
    }
  };

  private validateBudtenderPin = async (pin: string) => {
    try {
      const pinValidity: any = await validateTenantUserPin(
        this.props.client,
        pin
      );
      if (!pinValidity || pinValidity.invalidityCause) {
        this.setState({ wrongPin: true, goodPin: false });
      } else {
        this.setState({ goodPin: true, wrongPin: false });
      }
    } catch (err) {
      console.error(`couldn't validate ${strings.cashier} pin`, err);
    }
  };

  private getCurrentUser = async () => {
    try {
      const location = await getCurrentLocation(this.props.client);
      this.setState({
        tenantId: location.tenantId,
        locationId: location.locationId
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export default (props: IProps) => (
  <ApolloConsumer>
    {client => (
      <CustomerDataContext.Consumer>
        {loggedCustomer => (
          <ConfigurationLoaderContext.Consumer>
            {config =>
              config && (
                <AppStateContext.Consumer>
                  {([appState]) => (
                    <RedeemConfirmation
                      client={client}
                      loggedCustomer={loggedCustomer}
                      locationName={appState.locationName}
                      rewardImageBaseUrl={config.reward_images_base_url}
                      {...props}
                    />
                  )}
                </AppStateContext.Consumer>
              )
            }
          </ConfigurationLoaderContext.Consumer>
        )}
      </CustomerDataContext.Consumer>
    )}
  </ApolloConsumer>
);



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/RedeemConfirmation/RedeemConfirmation.tsx